import { Box, Chip, Divider, Link, Stack, Typography } from "@mui/material";
import { Link as RouterLink, useOutletContext } from "react-router-dom";

export default function KpiFinder(props) {
    // TODO: fetch data from server { search: "...", filters: { [key]: [value] }, sort_by: { [key]: [value] } }
    const { kpiData } = useOutletContext();

    return (
        <Box>
            <Stack divider={<Divider />}>
                {kpiData?.map((kpi) => (
                    <Box key={kpi.id} sx={{ display: "flex", paddingY: 2 }}>
                        <Box>
                            <Link
                                component={RouterLink}
                                to={`/kpis/${kpi.id}`}
                                sx={{
                                    textDecoration: "none",
                                    "&:hover": { textDecoration: "underline" },
                                }}
                            >
                                <Typography fontWeight="bold" color="text.primary" gutterBottom>
                                    {kpi.title}
                                </Typography>
                            </Link>
                            <Box
                                sx={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: 0.4,
                                }}
                            >
                                {Boolean(kpi.kpi_code) && <Chip label={kpi.kpi_code} size="small" />}
                                <Chip label={kpi.kpi_type?.title} size="small" variant="outlined" />
                                <Divider orientation="vertical" flexItem />
                                {kpi.stakeholder_groups?.map((group, index) => (
                                    <Box
                                        key={group.id}
                                        component="span"
                                        sx={{
                                            color: "gray",
                                            "&:hover": {
                                                textDecoration: "underline",
                                            },
                                        }}
                                    >
                                        {index != 0 ? ", " : ""}
                                        {group.title}
                                    </Box>
                                ))}
                            </Box>
                        </Box>
                        <Box sx={{ marginLeft: "auto", color: "gray" }}>
                            <Box>updated</Box>
                            <Box>{new Date(kpi.updated_at).toLocaleDateString()}</Box>
                        </Box>
                    </Box>
                ))}
            </Stack>
        </Box>
    );
}
